




	// @ts-ignore
    import _ from './CBlockTitle.ts'; export default _;
